import React from 'react';
import { bool, node, string } from 'prop-types';
import { Tooltip } from 'primereact/tooltip';
import { classNames } from 'primereact/utils';
import AUIField from '@ancert/aui-field';
import { keyGenerator } from '@ancert/aui-utils';
/**
 * @component
 * @param {object} props
 *  @param {string} props.className
 * @param {string} props.label
 * @param {React.ReactNode} props.children
 * @param {boolean} props.condensed
 * @param {string} props.tooltipFieldContent
 * @returns {React.ReactElement}
 */
const Field = ({ className, label, children, condensed, tooltipFieldContent }) => {
  /**
   * Generamos una clase única para linkar el icono con el
   * Tooltip y evitar la generación masiva de elementos en
   * DOM cuando se instancian los componentes.
   */
  const key = `c-pe-field--tooltip-${keyGenerator()}`;
  const fieldClassName = classNames('c-pe-field', className);
  const fieldContentClassName = classNames(['c-pe-field--bolder', 'u-txt:ellipsis', key]);

  return (
    <AUIField readOnly label={label.toString()} className={fieldClassName} condensed={condensed}>
      <div className={fieldContentClassName}>{children}</div>
      <Tooltip target={`.${key}`} content={tooltipFieldContent} />
    </AUIField>
  );
};

Field.propTypes = {
  className: string,
  label: string.isRequired,
  children: node,
  condensed: bool,
  tooltipFieldContent: string,
};

Field.defaultProps = {
  className: '',
  children: '',
  condensed: false,
  tooltipFieldContent: '',
};

export default Field;
